import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Tooltip } from '@instructure/ui-tooltip';
/**
 * Renders text that will truncate after a certain number of lines
 * and show a tooltip with the full text on hover if truncated.
 * There are a few versions of this in Canvas. However, this one is meant to be re-usable
 * everywhere.
 */
var TruncateWithTooltip = function TruncateWithTooltip(_ref) {
  var children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$maxTooltipWidth = _ref.maxTooltipWidth,
    maxWidth = _ref$maxTooltipWidth === void 0 ? '20rem' : _ref$maxTooltipWidth,
    linesAllowed = _ref.linesAllowed,
    horizontalOffset = _ref.horizontalOffset,
    backgroundColor = _ref.backgroundColor;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTruncated = _useState2[0],
    setIsTruncated = _useState2[1];
  var handleUpdate = function handleUpdate(truncated) {
    if (truncated !== isTruncated) {
      setIsTruncated(truncated);
    }
  };
  return isTruncated ? /*#__PURE__*/React.createElement(Tooltip, {
    as: "div",
    placement: placement,
    color: backgroundColor,
    offsetX: horizontalOffset,
    renderTip: function renderTip() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          overflowWrap: 'break-word',
          maxWidth: maxWidth
        }
      }, children);
    }
  }, /*#__PURE__*/React.createElement(TruncateText, {
    maxLines: linesAllowed,
    ignore: [' ', '.', ','],
    ellipsis: " ...",
    onUpdate: handleUpdate
  }, children)) : /*#__PURE__*/React.createElement(TruncateText, {
    maxLines: linesAllowed,
    onUpdate: handleUpdate
  }, children);
};
export default TruncateWithTooltip;